<template>
  <a-locale-provider :locale="lang === 'zh-cn' ? cn : en">
    <div id="app">
      <router-view />
    </div>
  </a-locale-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import enUs from 'ant-design-vue/lib/locale-provider/en_US'
import {mapGetters, mapState} from 'vuex'
export default {
  data() {
    return {
      cn: zhCN,
      en: enUs
    }
  },
  computed: {
    // ...mapGetters(['token'])
    ...mapState(['lang'])
  },
  sockets: {
    reloadWindow (ev) {
      console.log(ev)
      // window.location.href = window.location.href
      window.location.reload()
    }
  },
  methods: {
    setTheme () {
      let app = document.getElementById('app')
      let currentTheme = localStorage.getItem('theme')
      console.log(app)
      if (currentTheme) {
        app.className = `theme_${currentTheme}`
      } else {
        localStorage.setItem('theme', 'default')
        app.className = `theme_default`
      }
    }
  },
  mounted() {
    // let Socket = new WebSocket('ws://192.168.1.202:3000')
    // console.log(Socket)
    // Socket.onopen = (ev) => {
    //   console.log('connect')
    // }
    this.setTheme()
    let loadingDom = document.getElementById('loading')
    loadingDom && document.body.removeChild(loadingDom)
  },
  created() {
    // 移除加载动画
    // let loadingDom = document.getElementById('loading')
    // loadingDom && document.body.removeChild(loadingDom)
    // console.log(document.getElementById('loading'))
  }
}
</script>
<style lang="less">
  @import './assets/css/zTreeStyle.css';
</style>